import { PlanFinGroupDetail } from "tm-shared/types";

export const makePlans = (dirtyPlans: Record<string, PlanFinGroupDetail>) => {
    return Object.values(dirtyPlans || {})
        .map(({ details }) => details)
        .flat()
        .reduce((acc, product) => {
            acc[product.barcode] = {
                type: product.type,
                stage: product.stage,
            };
            return acc;
        }, {});
};
